import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useReportContext } from '../../../../context/DetailContext';
import { MapItemTypeData } from '../../../detail/data';

interface ItemStateMapProps {
  groupCategory: string;
}

const CaseSearchMap = ({ groupCategory }: ItemStateMapProps) => {
  const { lat, lng, geom } = useReportContext();

  // kakao 객체 보관
  const mapRef = useRef<kakao.maps.Map | null>(null);
  const markerRef = useRef<kakao.maps.Marker | null>(null);
  const polygonRef = useRef<kakao.maps.Polygon | null>(null);

  // “현재 위치” 기준 보관
  const centerRef = useRef<{ lat: number; lng: number }>({ lat, lng });

  const getMarkerImage = () => {
    if (!groupCategory) return '/assets/images/marker/etc.svg';
    const item = MapItemTypeData.find((data) => data.value === groupCategory);
    return item ? item.markerImg : '/assets/images/marker/etc.svg';
  };

  useEffect(() => {
    if (!(window.kakao && window.kakao.maps)) return;

    const container = document.getElementById('CaseSearchMap') as HTMLElement;
    if (!container) return;

    const options = {
      center: new window.kakao.maps.LatLng(lat, lng),
      draggable: true,
      level: 3,
    };

    // 기본 지도 생성
    const map = new window.kakao.maps.Map(container, options);
    mapRef.current = map;

    // 마커 생성
    const markerImage = new window.kakao.maps.MarkerImage(
      getMarkerImage(),
      new window.kakao.maps.Size(46, 56),
    );
    const marker = new window.kakao.maps.Marker({
      position: new window.kakao.maps.LatLng(lat, lng),
      map,
      image: markerImage,
    });
    markerRef.current = marker;

    // 폴리곤 초기 생성(있으면)
    if (geom.length > 0) {
      const polygonPath = geom.map(
        ([lng, lat]) => new window.kakao.maps.LatLng(lat, lng),
      );
      const polygon = new window.kakao.maps.Polygon({
        path: polygonPath,
        strokeWeight: 3,
        strokeColor: '#00B155',
        strokeOpacity: 0.8,
        fillColor: '#00E989',
        fillOpacity: 0.5,
      });
      polygon.setMap(map);
      polygonRef.current = polygon;
    }

    // “현재 위치” 잔존값 보관
    centerRef.current = { lat, lng };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lat, lng, geom, groupCategory]);

  // 컨트롤 버튼: 확대/축소/현재 위치로
  const zoomIn = () => {
    const map = mapRef.current;
    if (!map) return;
    map.setLevel(map.getLevel() - 1);
  };

  const zoomOut = () => {
    const map = mapRef.current;
    if (!map) return;
    map.setLevel(map.getLevel() + 1);
  };

  const recenter = () => {
    const map = mapRef.current;
    if (!map) return;
    const { lat, lng } = centerRef.current;
    map.setCenter(new kakao.maps.LatLng(lat, lng));
  };

  return (
    <Container>
      <MapContainer id="CaseSearchMap" />

      {/* 좌상단: 컨트롤 버튼 3종 */}
      <Controls>
        <CtrlBtn onClick={recenter} title="현재 위치로">
          <img src="/assets/images/icon/rocation.svg" alt="현재 위치로" />
        </CtrlBtn>
      </Controls>
    </Container>
  );
};

export default CaseSearchMap;

const MapContainer = styled.div`
  width: 100%;
  height: 240px;
  text-align: center !important;
  display: flex;
  overflow: hidden;

  [id^='_box_util_'] {
    display: none !important;
  }
`;

const Container = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  position: relative;
  text-align: center !important;
`;

const Button = styled.div`
  position: absolute;
  z-index: 2;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  box-shadow:
    (0px 8px 32px 0px #272c3614), (0px 2px 4px 0px #272c361f),
    (0px 4px 12px 0px #272c360d);
  display: flex;

  img {
    width: 16px;
    height: 16px;
  }
`;

const Controls = styled.div`
  position: absolute;
  height: 100%;
  padding: 16px 0px;
  right: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 2;
  justify-content: space-between;
`;

const CtrlBtn = styled(Button)`
  position: relative;
  right: auto;
  top: auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
`;

const ZoomDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
